import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop ensures every route transition across the app smoothly
 * scrolls the user back to the top of the viewport.
 */
export const ScrollToTop: React.FC = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        document.body.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });

        const main = document.querySelector("main");
        if (main && main.scrollTop > 0) {
            main.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }
    }, [pathname, search]);

    return null;
};
